import { GraphQLResult } from '@aws-amplify/api-graphql';
import { AttendeeStatus } from '../../constans/attendee-enums';
import { GetActiveAttendeesCountQuery, GetAttendeesQuery } from '../../graphql/API';
import { TGraphQLSubscriptions, graphqlClient } from '../graphql-api-client/graphql-api-client';
import * as queries from '../../graphql/queries';
import { SortDirection } from '../../constans/common-constants';
import { IKnovioCommand } from './live-stream-status-dao';
import { knovioCommand } from '../../graphql/mutations';
import { IDisconnectAttendeeCommandObject } from '../../utils/helpers/commands-helpers';

export interface IAttendee {
    arrival: string;
    attendeeStatus: AttendeeStatus;
    email: string;
    name: string;
    presentationId: string;
    viewerId: string;
    departure: string;
}

interface ISortParams {
  name: string;
  direction: SortDirection;
}

export interface IGetAttendeePayload {
  filterStatus: AttendeeStatus[];
  size: number;
  page: number;
  query: string;
  sort: ISortParams;
  presentationId: string;
  nextToken?: string;
  sortDirection?: string;
}

export interface IGetActiveAttendeesCountPayload {
  presentationId: string;
  statuses: AttendeeStatus[];
}

export type TSubscription<T> = (
    presentationId: string | null,
    doneCallback: (data: T) => void,
    retrySubscriptionFn: () => TGraphQLSubscriptions
) => TGraphQLSubscriptions;

export interface IOnUpdateAttendee {
  onUpdateAttendee: IAttendee;
}


export const getAttendeesByFilter = (payload: IGetAttendeePayload): Promise<GraphQLResult<GetAttendeesQuery>> => {
  const payloadString = JSON.stringify(payload);
  return graphqlClient.operation<GetAttendeesQuery>({
    query: queries.getAttendees,
    variables: {
      input: payloadString
    }
  });
};

export const getActiveAttendeesCount = (payload: IGetActiveAttendeesCountPayload): Promise<GraphQLResult<GetActiveAttendeesCountQuery>> => {
  const payloadString = JSON.stringify(payload);

  return graphqlClient.operation<GetActiveAttendeesCountQuery>({
    query: queries.getActiveAttendeesCount,
    variables: {
      input: payloadString
    }
  });
};

export const sendChangeConnectionStatusAttendeeCommand = async (
  body: IDisconnectAttendeeCommandObject
): Promise<GraphQLResult<{ commandsMutation: IKnovioCommand }>> => {
  return graphqlClient.operation({
    query: knovioCommand,
    variables: {
      input: {
        ...body
      }
    }
  });
};